import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useNavigateBack = (fallbackRoute: string) => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(() => {
    if (location.key === "default") {
      navigate(fallbackRoute);
    } else {
      navigate(-1);
    }
  }, [location.key, navigate, fallbackRoute]);
};

export default useNavigateBack;
